import React, { useState } from 'react';
import { createPortal } from 'react-dom';

type Props = Record<string, unknown> & {
  children: JSX.Element;
  title?: string;
};

export const IFrame = ({ children, title, ...props }: Props): JSX.Element => {
  const [contentRef, setContentRef] = useState<HTMLIFrameElement | null>(null);
  const mountNode = contentRef?.contentWindow?.document?.body;

  return (
    <iframe {...props} title={title} sandbox="allow-same-origin" ref={setContentRef}>
      {mountNode && createPortal(children, mountNode)}
    </iframe>
  );
};
